import { render, staticRenderFns } from "./form-reset-password-email.vue?vue&type=template&id=d7bf8e7a&scoped=true&"
import script from "./form-reset-password-email.vue?vue&type=script&lang=js&"
export * from "./form-reset-password-email.vue?vue&type=script&lang=js&"
import style0 from "./form-reset-password-email.vue?vue&type=style&index=0&id=d7bf8e7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7bf8e7a",
  null
  
)

export default component.exports